import { Observable } from 'rxjs/Observable';
import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class SharedService {
    data = new EventEmitter<any>();
}
